import { ENVIRONMENT } from '../environment/environment.service';
import { HttpClient } from '@angular/common/http';
import { AppSettings, Environment, Response } from '@viso/core/models';
import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  getSetting(key: string) {
    return this.http
      .get(`${this.environment.API_URL}/app-settings/getValues?keys=${key}`)
      .pipe(map((res: Response<AppSettings[]>) => res.body));
  }

  getSettings(keys: string[]) {
    return this.http
      .get(`${this.environment.API_URL}/app-settings/getValues?keys=${keys.join(',')}`)
      .pipe(map((res: Response<AppSettings[]>) => res.body));
  }

}
